export class Constants {
    // without smooth customer perk.
    public static readonly SPECIALIST_COST: number = 33000;
    public static readonly HIT_MAN_COST: number = 21000;
    public static readonly THUG_COST: number = 10000;

    // 1 billion cash = 5 million negative, so:
    public static readonly CASH_EQUIVALENT_OF_ONE_REP = 200;
}
